module.exports = __webpack_public_path__ + "media/images/color_admin_v3/coming-soon-f6f494dcf1e79a19d49e14cbab4e9375.jpg";